<template>
  <b-navbar
    variant="faded"
    toggleable="lg"
  >
    <b-navbar-brand
      v-if="isLoggedIn"
      :to="{name: 'home'}"
      class="abs-center-x"
      tag="h1"
    >
      <img
        alt="Schindelhauer Logo"
        src="../assets/logo.svg"
        class="nav-brand-logo"
      >
    </b-navbar-brand>
    <b-navbar-brand
      v-else
      :to="{name: 'lang'}"
      class="abs-center-x"
      tag="h1"
    >
      <img
        alt="Schindelhauer Logo"
        src="../assets/logo.svg"
        class="nav-brand-logo"
      >
    </b-navbar-brand>
    <b-navbar-toggle
      target="nav-collapse"
      :class="{collapsed: !isExpanded}"
    >
      <template>
        <span class="burger-wrapper">
          <div class="burger">
            <div class="burger__icon" />
          </div>
        </span>
      </template>
    </b-navbar-toggle>
    <b-collapse
      id="nav-collapse"
      is-nav
    >
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <NavbarUserDropDown />
        <NavbarLanguageSwitch />
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import NavbarLanguageSwitch from "./NavbarLanguageSwitch.vue";
import NavbarUserDropDown from "./NavbarUserDropDown.vue";

export default {
  name: "Navigation",
  components: {
    NavbarLanguageSwitch,
    NavbarUserDropDown
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.state.signedIn;
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (collapseId == "nav-collapse") {
        this.isExpanded = isJustShown;
      }
    });
  }
};
</script>